import { Stack } from '@mantine/core';
import { useParams } from 'react-router-dom';

import { useGetPageReport } from '../api/getReport';
import { ReportCard } from '../components/ReportCard';

import { ListLoader, ServerError } from '@/components';

export const AiReportPage = () => {
  const { reportId = '' } = useParams();
  const reportQuery = useGetPageReport({ reportId });

  if (reportQuery.isLoading) return <ListLoader />;
  if (reportQuery.isError || !reportQuery.data) {
    return (
      <ServerError onRetry={() => reportQuery.refetch()} isFetching={reportQuery.isFetching} />
    );
  }

  return (
    <Stack p="md">
      <ReportCard report={reportQuery.data.report} batch={reportQuery.data.batch} />
    </Stack>
  );
};
